import { createApp } from 'vue'
import App from './App.vue'

import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "./styles/theme.scss"
import router from '@/router';

import store from '@/store';

import "@/permission"; // permission control
import { totalCommon } from "./common.js";

import zhLocale from 'element-plus/es/locale/lang/zh-cn'

import "@/styles/gloable.scss";

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.mixin(totalCommon);
//element 全局默认大小为small
app.config.globalProperties.$ELEMENT = {
    size: 'small',
}
app.use(ElementPlus, { locale: zhLocale }).use(router).use(store);
app.mount('#app')
